import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalCard } from '@datapad/common-controls';
import { Add } from '@mui/icons-material';
import { AppBar, Box, FormControl, IconButton, InputLabel, MenuItem, Toolbar as MuiToolbar, Select, Tooltip, } from '@mui/material';
import React from 'react';
import { PlayerCreationForm } from './PlayerCreationForm.js';
var ModalStatus;
(function (ModalStatus) {
    ModalStatus[ModalStatus["None"] = 0] = "None";
    ModalStatus[ModalStatus["Creating"] = 1] = "Creating";
})(ModalStatus || (ModalStatus = {}));
export function Toolbar(props) {
    const { changeSelection, addPlayer } = props;
    const [modalStatus, setModalStatus] = React.useState(ModalStatus.None);
    return (_jsxs(_Fragment, { children: [_jsx(EditingModal, { modalStatus: modalStatus, onAddNewPlayer: (player) => {
                    console.log(`Adding new player "${player.userName}". ID: ${player.id}.`);
                    try {
                        addPlayer(player);
                    }
                    catch (error) {
                        console.error(`Couldn't insert new player "${player.userName}" due to an error.`, error);
                        throw error;
                    }
                    changeSelection(player);
                    setModalStatus(ModalStatus.None);
                }, onCancel: () => setModalStatus(ModalStatus.None) }), _jsx(AppBar, { position: "static", color: "default", elevation: 1, children: _jsxs(MuiToolbar, { variant: "dense", sx: {
                        justifyContent: 'space-between',
                        gap: 2,
                    }, children: [_jsx(PlayerSelectionDropDown, { ...props }), _jsx(Tooltip, { title: "Add new player", children: _jsx(IconButton, { color: "primary", onClick: () => setModalStatus(ModalStatus.Creating), children: _jsx(Add, {}) }) })] }) })] }));
}
function PlayerSelectionDropDown(props) {
    const { players, selection: selectedPlayer, changeSelection } = props;
    if (players.length === 0) {
        return _jsx(_Fragment, {});
    }
    const playerSelectionOptions = players.map((player) => (_jsx(MenuItem, { value: player.id, children: player.userName }, `player-selection-option-${player.id}`)));
    return (_jsx(Box, { sx: { minWidth: 200 }, children: _jsxs(FormControl, { size: "small", fullWidth: true, children: [_jsx(InputLabel, { id: "player-selection-label", children: "Player" }), _jsx(Select, { id: "player-selection-select", labelId: "player-selection-label", label: "Player", value: selectedPlayer?.id ?? '', onChange: (event) => {
                        changeSelection(players.find((p) => p.id === event.target.value));
                    }, children: playerSelectionOptions })] }) }));
}
function EditingModal(props) {
    const { modalStatus, onAddNewPlayer, onCancel } = props;
    if (modalStatus === ModalStatus.None) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(ModalCard, { open: true, onClose: onCancel, children: _jsx(PlayerCreationForm, { onSubmit: onAddNewPlayer, onCancel: onCancel }) }));
}
//# sourceMappingURL=Toolbar.js.map